import { useState } from 'react';
import { BatchHistoryTable } from '../components/BatchHistoryTable';
import { HistoryTable } from '../components/HistoryTable';
import { HistoryPageLayout, type HistoryTab } from '../../components/HistoryPageLayout';

export function VideoHistoryPage() {
  const [activeTab, setActiveTab] = useState<HistoryTab>('scan');
  const description =
    activeTab === 'scan'
      ? 'Completed and failed turntable-video scans. Use the row actions to view the video, copy the service response, or re-run with the current settings.'
      : 'Finished CSV batches. A batch appears here once every one of its scans has completed or failed.';

  return (
    <HistoryPageLayout
      activeTab={activeTab}
      onTabChange={setActiveTab}
      description={description}
    >
      {activeTab === 'batch' ? <BatchHistoryTable /> : <HistoryTable />}
    </HistoryPageLayout>
  );
}
